import { AutoSaveIndicator, RouteTabWithContent, TabsWithContent } from "@homebound/beam";
import { useMemo } from "react";
import { useRouteParams } from "src/hooks/useRouteParams";
import { PageHeader } from "src/routes/layout/PageHeader";
import { ProjectParams, projectPaths } from "src/routes/routesDef";
import { createProjectSettingsUrl } from "src/RouteUrls";
import { useProjectContext } from "../context/ProjectContext";
import { CheckoutSettingsTab } from "./CheckoutSettingsTab";
import { HomeownersTab } from "./HomeownersTab";
import { OverallTab } from "./OverallTab";
import { ScheduleTab } from "./ScheduleTab";
import { SetUpTab } from "./SetUpTab";
import { TeamMembersTab } from "./TeamMembersTab";

export function ProjectSettingsPage() {
  const { projectId } = useRouteParams<ProjectParams>();
  const { __typename } = useProjectContext();

  const tabs: RouteTabWithContent[] = useMemo(
    () => [
      {
        name: "Overall",
        href: createProjectSettingsUrl(projectId),
        path: projectPaths.settings,
        render: () => <OverallTab />,
      },
      {
        name: "Set Up",
        href: createProjectSettingsUrl(projectId, "setup"),
        path: `${projectPaths.settings}/setup`,
        render: () => <SetUpTab />,
      },
      {
        name: "Team Members",
        href: createProjectSettingsUrl(projectId, "teamMembers"),
        path: `${projectPaths.settings}/teamMembers`,
        render: () => <TeamMembersTab />,
      },
      {
        name: "Homeowner(s)",
        href: createProjectSettingsUrl(projectId, "homeowners"),
        path: `${projectPaths.settings}/homeowners`,
        render: () => <HomeownersTab />,
      },
      {
        name: "Schedule",
        href: createProjectSettingsUrl(projectId, "schedule"),
        path: `${projectPaths.settings}/schedule`,
        render: () => <ScheduleTab />,
      },
      ...(__typename === "Structure" || __typename === "Community" || __typename === "Lot"
        ? [
            {
              name: "Checkout",
              href: createProjectSettingsUrl(projectId, "checkoutSettings"),
              path: `${projectPaths.settings}/checkoutSettings`,
              render: () => <CheckoutSettingsTab projectType={__typename} />,
            },
          ]
        : []),
    ],
    [projectId, __typename],
  );

  return (
    <>
      <PageHeader title="Project Settings" left={<AutoSaveIndicator />} />
      <TabsWithContent tabs={tabs} />
    </>
  );
}
